// ===========================================================================
// Charge Capture (Módulo N) — Charge Capture & Validation Engine.
// Refactor Etapa 2: UI sobre el Clinical Design System (master-detail) y
// capa de servicio con el contrato real /api/charges/* (fake hasta que el
// backend del schema `billing` esté implementado).
// Ver docs/modulos/BillingV2/MODULO_N_CHARGE_CAPTURE.md.
// ===========================================================================
import React, { lazy } from "react";
import { CHARGE_CAPTURE_BASE_PATH } from "./common/constants";

const ChargeCapturePage = lazy(() => import("./pages/ChargeCapturePage"));

export const chargeCaptureRoutes = [
  { path: CHARGE_CAPTURE_BASE_PATH, element: <ChargeCapturePage /> },
];

export { ChargeCapturePage };
export { CHARGE_CAPTURE_BASE_PATH } from "./common/constants";
export default ChargeCapturePage;
